import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(theme => ({
	dialogPaper: {
		borderRadius: theme.spacing(2),
		overflow: "hidden",
		padding: 0
	},
	header: {
		background: `linear-gradient(135deg, ${colors.purple[500]} 0%, ${colors.purple[400]} 100%)`,
		color: colors.gray[0],
		padding: theme.spacing(2, 3),
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between"
	},
	headerTitleBlock: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(1)
	},
	headerTitle: {
		color: colors.gray[0],
		fontWeight: 600,
		fontSize: 18
	},
	headerSubtitle: {
		color: colors.purple[50],
		fontSize: 13,
		marginTop: 2
	},
	closeIconButton: {
		color: colors.gray[0],
		padding: 4
	},
	sparklesIcon: {
		"& path": {
			fill: "currentColor"
		}
	},
	body: {
		padding: theme.spacing(3),
		position: "relative",
		maxHeight: 320,
		overflowY: "auto"
	},
	copyButton: {
		position: "absolute",
		top: theme.spacing(2),
		right: theme.spacing(3),
		width: 24,
		height: 24,
		borderRadius: theme.spacing(1),
		padding: 0,
		backgroundColor: colors.purple[50],
		color: colors.purple[400],
		"&:hover": {
			backgroundColor: colors.purple[100]
		}
	},
	copyIcon: {
		fontSize: "1rem"
	},
	summaryText: {
		whiteSpace: "pre-line",
		fontSize: 14,
		lineHeight: 1.6,
		paddingRight: theme.spacing(4)
	},
	footer: {
		padding: theme.spacing(1, 3, 2)
	},
	footerButton: {
		padding: theme.spacing(1, 2),
		borderRadius: theme.spacing(1),
		height: theme.spacing(6),
		fontSize: 14
	},
	saveNoteButton: {
		backgroundColor: colors.purple[100],
		color: colors.purple[600],
		border: `1px solid ${colors.purple[200]}`,
		"&:hover": {
			backgroundColor: colors.purple[200]
		}
	},
	regenerateButton: {
		color: colors.purple[500]
	},
	moreInsightsButton: {
		backgroundColor: colors.purple[500],
		color: colors.gray[0],
		"&:hover": {
			backgroundColor: colors.purple[600]
		}
	}
}))

export default useStyles
